import { Heading, Text, VStack } from "@chakra-ui/react"

import stbtcToken from "#/assets/tokens/stbtc-token.svg"
import { FRIENDLY_DECIMALS_AMOUNT } from "#/shared/constants"
import { bigIntToHumanReadableFormat } from "#/shared/utils"

import DepositCarouselModalHeader from "../../DepositCarousel/DepositCarouselModalHeader"

type StbtcManageModalHeaderProps = {
  totalStbtcTokensToReturn?: bigint
}

export default function StbtcManageModalHeader({
  totalStbtcTokensToReturn,
}: StbtcManageModalHeaderProps) {
  return (
    <DepositCarouselModalHeader
      imageSrc={stbtcToken}
      imageProps={{ width: "74px" }}
    >
      <VStack alignItems="flex-start" gap="12px">
        <Heading variant="h3" fontSize="32px" lineHeight="40px">
          Manage stBTC
        </Heading>
        {totalStbtcTokensToReturn !== undefined &&
          totalStbtcTokensToReturn > 0n && (
            <Text variant="label">
              Total stBTC to return:{" "}
              {bigIntToHumanReadableFormat(
                totalStbtcTokensToReturn,
                18,
                FRIENDLY_DECIMALS_AMOUNT,
              )}{" "}
              stBTC
            </Text>
          )}
      </VStack>
    </DepositCarouselModalHeader>
  )
}
